export default [
  {
    path: '/admin/product-prices',
    name: 'product-price',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/price')
  },
  {
    path: '/admin/product-prices/update',
    name: 'product-price-update',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/price/update.vue')
  }
]